import React from 'react';
import { Container, Typography, Grid, Card, CardActionArea } from '@mui/material';
import { 
  WineBar as WineIcon, 
  Receipt as OrderIcon, 
  Category as CategoryIcon,
  LocalBar as TypeIcon,
  Store as WineryIcon,
  LocalShipping as ShippingIcon,
  LocalOffer as DiscountIcon,
  Collections as SectionIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const AdminDashboard = () => {
  const navigate = useNavigate();

  const adminSections = [
    {
      title: 'Gestión de Denominaciones de Origen',
      description: 'Administra las denominaciones de origen',
      icon: <CategoryIcon sx={{ fontSize: 48, color: 'secondary.main', mb: 2 }} />,
      path: '/admin/categories'
    },
    {
      title: 'Gestión de Bodegas',
      description: 'Administra las bodegas y productores',
      icon: <WineryIcon sx={{ fontSize: 48, color: 'secondary.main', mb: 2 }} />,
      path: '/admin/wineries'
    },
    {
      title: 'Gestión de Tipos',
      description: 'Administra los tipos de vinos',
      icon: <TypeIcon sx={{ fontSize: 48, color: 'secondary.main', mb: 2 }} />,
      path: '/admin/types'
    },
    {
      title: 'Gestión de Vinos',
      description: 'Administra el catálogo de vinos',
      icon: <WineIcon sx={{ fontSize: 48, color: 'secondary.main', mb: 2 }} />,
      path: '/admin/wines'
    },
    {
      title: 'Gestión de Pedidos',
      description: 'Administra los pedidos de clientes',
      icon: <OrderIcon sx={{ fontSize: 48, color: 'secondary.main', mb: 2 }} />,
      path: '/admin/orders'
    },
    {
      title: 'Precios de Envío',
      description: 'Configura tarifas y zonas de envío',
      icon: <ShippingIcon sx={{ fontSize: 48, color: 'secondary.main', mb: 2 }} />,
      path: '/admin/shipping'
    },
    {
      title: 'Códigos de Descuento',
      description: 'Gestiona códigos promocionales',
      icon: <DiscountIcon sx={{ fontSize: 48, color: 'secondary.main', mb: 2 }} />,
      path: '/admin/discounts'
    },
    {
      title: 'Secciones de la Página',
      description: 'Gestiona secciones como "Los mejores de la bodega"',
      icon: <SectionIcon sx={{ fontSize: 48, color: 'secondary.main', mb: 2 }} />,
      path: '/admin/sections'
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography 
        variant="h3" 
        sx={{ 
          mb: 4, 
          fontFamily: '"Playfair Display", serif',
          fontWeight: 600,
          textAlign: 'center'
        }}
      >
        Panel de Administración
      </Typography>

      <Typography 
        variant="h6" 
        color="text.secondary"
        sx={{ 
          mb: 4,
          textAlign: 'center'
        }}
      >
        Bienvenido al sistema de administración de Vinogenes
      </Typography>

      <Grid container spacing={3}>
        {adminSections.map((section, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={{ height: '100%' }}>
              <CardActionArea 
                onClick={() => navigate(section.path)}
                sx={{ 
                  p: 3, 
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center'
                }}
              >
                {section.icon}
                <Typography variant="h6" gutterBottom>
                  {section.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {section.description}
                </Typography>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default AdminDashboard; 